export default __webpack_public_path__ + "media/images/logo-3c0c9790b33126b6d1e3ef6c972bf4c1.svg";